import { Component, OnInit, OnDestroy } from '@angular/core';
import {
	AuthenticationService,
	UserService,
	ImpersonationService
} from '@edassist/api';
import { Subscription } from 'rxjs';

@Component({
	selector: 'tu-impersonation-bar',
	templateUrl: './impersonation-bar.component.html',
	styleUrls: ['./impersonation-bar.component.scss']
})
export class ImpersonationBarComponent implements OnInit, OnDestroy {
	loggedInUser;
	isImpersonationEnabled = false;
	private readonly subscriptions = new Subscription();

	constructor(
		private readonly authService: AuthenticationService,
		private readonly userService: UserService,
		private readonly impersonationService: ImpersonationService
	) {}

	ngOnInit(): void {
		this.subscriptions.add(
			this.authService.currentUser.subscribe((user) => {
				this.loggedInUser = {
					display: `${user?.firstName} ${user?.lastName}`,
					value: user
				};
			})
		);
		this.subscriptions.add(
			this.impersonationService.isImpersonation.subscribe((data) => {
				this.isImpersonationEnabled = data;
			})
		);
	}
	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
